<template>
	<div>
		<div class="login-demo " id="box">


			<div class="login-wrap">
				<el-row type="flex" justify="center" id="login-border">
					<!-- 登录框 -->
					<el-form ref="loginForm" :rules="formRules" :model="user" status-icon label-width="70px">
						<transition name="el-fade-in-linear">
							<el-tabs v-show="show" :stretch="true" v-model="activeName" @tab-click="handleClick">
								<el-tab-pane label="登录" name="login">
									<el-form-item prop="username" label="用户名" align="left">
										<el-input v-model="user.username" placeholder="请输入用户名"></el-input>
									</el-form-item>
									<el-form-item prop="password" label="密 码" align="left">
										<el-input v-model="user.password" show-password placeholder="请输入密码">
											<template slot="prepend"></template>
										</el-input>
									</el-form-item>
									<el-form-item prop="vcode">
										<!--滑动验证码-->
										<Vcode :complete="user.vcode" @success="success" />
									</el-form-item>
									<!-- <el-checkbox id="savePassword"  @click="savePassword()">记住密码
									</el-checkbox>
									<router-link to="/forget">忘记密码</router-link> -->
									<!-- <br> -->


									<el-form-item>
										<el-button type="primary" @click="doLogin('loginForm')" :disabled="!user.vcode">
											登 录</el-button>
									</el-form-item>
								</el-tab-pane>
								<!-- 注册框 -->
								<el-tab-pane label="注册" name="register">
									<el-form-item prop="username" label="用户名">
										<el-input v-model="user.username" placeholder="请输入用户名"></el-input>
									</el-form-item>
									<!-- 									<el-form-item prop="email" label="邮箱">
										<el-input v-model="user.email" placeholder="请输入邮箱"></el-input>
									</el-form-item> -->
									<el-form-item prop="password" label="设置密码">
										<el-input v-model="user.password" show-password placeholder="请输入密码"></el-input>
									</el-form-item>
									<el-form-item prop="password" label="确认密码">
										<el-input v-model="user.repassword" show-password placeholder="请输入密码">
										</el-input>
									</el-form-item>
									<el-form-item prop="inviterid" label="邀请ID">
										<el-input v-model="user.inviterid"  placeholder="请输入密码">
										</el-input>
									</el-form-item>
									<center>
										<el-checkbox v-model="userservice" id="savePassword" @click="savePassword()">
											确认阅读并同意用户协议
										</el-checkbox>
										<el-link :underline="false" type="danger" href="/lab-service_zh-CN.html"
											target="_blank">点我阅读</el-link>
									</center>
									<br />
									<el-form-item>
										<el-button type="primary" icon @click="doRegister('loginForm')">注册账号</el-button>
									</el-form-item>
								</el-tab-pane>
							</el-tabs>
						</transition>
					</el-form>
				</el-row>
				<center>
					<el-link :underline="false" href="/lab-service_cn-EN.html" target="_blank">Terms of Service
					</el-link><br>
					<el-link :underline="false" href="/labs-privacy_en-EN.html" target="_blank">Privacy Policy</el-link>
					<br>
					<el-link :underline="false" href="/labs-disclaimer-EN.html" target="_blank">Disclaimer</el-link>
				</center>
			</div>

		</div>
	</div>


</template>

<script>
	name: "login"
	var axios = require('axios');
	var qs = require('qs');
	import Vcode from '../comm/Vcode'
	export default {
		name: "login",
		components: {
			Vcode
		},
		data() {

			return {
				show: true,
				userservice: false,
				activeName: "login",
				checked: false,
				url: this.$global.url,//"http://127.0.0.1:8083", //"https://api.starmap.stream",
				user: {
					username: "",
					password: "",
					vcode: false,
					vcodeTime: 0,
					inviterid:0
				},
				// 通过 formRules 属性传入约定的验证规则
				formRules: {
					username: [{
						required: true,
						message: "用户名不能为空",
						trigger: "blur"
					}],
					password: [{
							required: true,
							message: "密码不能为空",
							trigger: "blur"
						},
						{
							type: "string",
							min: 6,
							message: "密码不能小于6位",
							trigger: "blur"
						}
					],
					// bug--由于此处登录和注册共用一个el-form，因此只能绑定一个rules,如果邮箱设置为必填，将导致无法登陆。一般情况下，将登录和注册分别放在不同的el-form中，为它们设置不同的rules
					email: [
						// { required: true, message: "请输入邮箱地址", trigger: "blur"  },
						{
							type: "email",
							message: "请输入正确的邮箱地址",
							trigger: ["blur", "change"]
						}
					],
					inviterid:0
				},
				vcode: [{
					validator: (rule, value, callback) => {
						if (!value) {
							callback(new Error('请完成图片验证'))
						} else {
							const time = new Date().getTime() - this.user.vcodeTime
							// 超时3分钟就重新验证吧
							if (time / 1000 / 60 > 3) {
								this.user.vcode = false
								callback(new Error('请完成图片验证'))
							}
							callback()
						}
					},
					trigger: 'change'
				}]
			}
		},
		created() {},
		mounted() {
			this.isInvite()
		},
		methods: {
			isInvite(){
				if( this.$urlParse.getUrlKey('code')){
					this.user.inviterid=this.$urlParse.getUrlKey('code')
					console.log(this.user.inviterid)
					this.activeName='register'
				}
			},
			success(x) {
				this.user.vcode = true
				this.user.vcodeTime = new Date().getTime()
			},
			// 登录
			doLogin(form) {
				let that = this;


				this.$refs[form].validate((valid) => {
					if (valid) {

						var data = qs.stringify({
							'username': this.user.username,
							'password': this.user.password
						});
						var config = {
							method: 'post',
							url: this.url + '/api/login',
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
							data: data
						};
						axios(config)
							.then(function(res) {
								let uri = that.$urlParse.getUrlKey('redirect')
								uri = decodeURIComponent(uri)
								if (uri === null || uri === 'null') {
									uri = "/labs/eth-index"
								}


								if (res.data.code === 0) {
									localStorage.setItem("token", res.data.data.token)
									console.log("uri:" + uri)
									if (uri === null || uri === 'null') {
										console.log("uri是null")
										that.$router.push("/labs/eth-index");
									}

									// uri=uri===null:uri?"/labs/eth-index"
									let nameList = uri.split("/")
									let routername = nameList[nameList.length - 1]
									that.$router.push({
										path: "/" + uri,
										name: routername
									});
								} else {
									that.$message.error(res.data.msg)
								}
							})
					} else {
						return false;
					}
				});
			},
			// 注册账号
			doRegister(form) {
				let that = this
				if (this.userservice === false) {
					this.$message.error("请先阅读并同意用户服务条款")
					return
				}
				console.log(this.user.inviterid,this.inviterid)
				this.$refs[form].validate((valid) => {
					if (valid) {
						var data = qs.stringify({
							'username': this.user.username,
							'password': this.user.password,
							'inviterid':this.user.inviterid
						});
						var config = {
							method: 'post',
							url: this.url + "/api/reg",
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
							data: data
						};

						axios(config)
							.then(function(response) {
								if (response.data.code === 0) {
									that.$message.success(response.data.msg)
									that.activeName = "login";
								}else if (response.data.code === 4001) {
									that.$message.error(response.data.msg)
									
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(function(error) {
								console.log(error);
							});


					} else {
						return false;
					}
				});
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			// 记住密码
			savePassword() {
				if (document.getElementById("savePassword").checked) {
					var username = this.user.username;
					var password = this.user.password;
					window.sessionStorage.username = username;
					window.sessionStorage.password = password;
					localStorage.rmbPassword = true;
				} else {
					localStorage.rmbPassword = false;
				}
			},


		}
	}
</script>

<style scoped>
	* {
		touch-action: pan-y;
	}

	/* 公共样式 */
	#login-border {
		background-color: rgba(0, 0, 0, 0.25);
		border-radius: 0.4rem;

	}

	li {
		list-style: none;
		float: left;
	}

	.login-demo {
		position: fixed;
		width: 100%;
		height: 100%;
		/* background: url("../assets/images/bg2.png") no-repeat; */
		background: url(../../img/bg.jpg);
		background-repeat: repeat;
		/* background-size: cover; */
		top: 0px;
		left: 0px;
		overflow: hidden;
	}

	.login-wrap {
		/* background: url("../assets/images/login_bg.png") no-repeat; */
		width: 400px;
		height: 310px;
		margin: auto auto;
		margin-top: auto;
		/* margin-left: 272px; */
		border-radius: 6px;
		line-height: 20px;
		padding-top: 10%;
		/* padding:auto auto; */
	}

	.el-tabs>>>.el-tabs__item {
		font-size: 18px;
		margin: 5px auto;
	}

	.el-tabs__nav {
		font-size: 18px;
	}

	a {
		text-decoration: none;
		color: #606266;
		font-size: 14px;
		float: right;
	}

	a:hover {
		color: coral;
	}

	.el-checkbox {
		text-indent: 4px;
	}

	>>>.el-form-item__label {
		padding: 0px 4px 0 0;
	}

	>>>.el-checkbox__label {
		padding-left: 0px;
	}

	.el-button {
		width: 118%;
		margin-left: -40px;
		background-color:
			#16696a;
		letter-spacing: 5px;
		border: 0px;
	}
</style>
